module.exports = __webpack_public_path__ + "img/CC.ebd4f2fa.svg";